import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "../../axios";
import Search from "../search/Search";
import ReactPaginate from "react-paginate";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";
import "./users.scss";

const Users = () => {
  const [users, setusers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const productsPerPage = 5;
  const productsPerList = 50;
  const pagesVisited = pageNumber * productsPerPage;
  let displayUsers = [];
  const pageCount = Math.ceil(filtered.length / productsPerPage);

  const changePage = ({ selected }) => {
    // console.log(selected);
    setPageNumber(selected);
  };

  useEffect(() => {
    axios
      .get("users/all")
      .then((res) => {
        setusers(res?.data);
        setFiltered(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error("Something went wrong!");
        console.log(err);
      });
  }, []);

  return (
    <div className="users p-5 text-left">
      <div className="page-title ">
        <h1> Users</h1>
      </div>

      <div className="row ml-n4 search">
        <div className="col-md-9">
          <Search
            data={users}
            title="user"
            filtered={setFiltered}
            setPageNumber={setPageNumber}
          />
        </div>

        <div className="col-md-3">
          <Link to="/users/add" className="myButton">
            Add New User
          </Link>
        </div>
      </div>

      <div className="listimi-tabela">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="listimi-head">
              <div className="row ">
                <div className="col-1">ID</div>
                <div className="col-3">Name</div>
                <div className="col-3">Email</div>
                <div className="col-1">Role</div>
                <div className="col-2">Status</div>
                <div className="col-1 hideme"> </div>
                <div className="col-1 hideme"> </div>
              </div>
            </div>
            {
              (displayUsers = filtered
                ?.slice(pagesVisited, pagesVisited + productsPerPage)
                ?.map((filtered) => {
                  return (
                    <div className="listimi showme" key={filtered.id}>
                      <div className="row ">
                        <div className="col-1">{filtered.id} </div>
                        <div className="col-3">{filtered.full_name} </div>
                        <div className="col-3">{filtered.email} </div>

                        <div className="col-1">
                          {filtered.role == 1 ? "Admin" : "Client"}{" "}
                        </div>

                        <div className="col-2">
                          {filtered.active ? "Active" : "Passive"}{" "}
                        </div>

                        <div className="col-1 delete">
                          <Link
                            className={"fa fa-trash"}
                            to={"/users/delete/" + filtered.id}
                          ></Link>
                        </div>

                        <div className="col-1 edit">
                          <Link
                            className={"fa fa-edit"}
                            to={"/users/edit/" + filtered.id}
                          ></Link>
                        </div>
                      </div>
                    </div>
                  );
                }))
            }
          </>
        )}
      </div>
      <div className="row mt-5">
        <div className="col-12">
          {users.length >= productsPerPage ? (
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              pageCount={pageCount}
              onPageChange={changePage}
              containerClassName={"paginationBttns"}
              previousLinkClassName={"previousBttn"}
              nextLinkClassName={"nextBttn"}
              disabledClassName={"paginationDisabled"}
              activeClassName={"paginationActive"}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default Users;
